import axiosInstance from "../api/axiosConfig";

export const getMaintenanceStatus = async () => {
  try {
    const response = await axiosInstance.head("/system");
    return response; // Return the full response to check the status code
  } catch (error) {
    if (error.response && error.response.status === 503) {
      return { data: true }; // Return a truthy response to indicate maintenance mode
    }
    throw error;
  }
};
